export const updatePriceBlockPromo = () => {
    const block = document.querySelector('.product-price-block');
    if (!block) return;

    const wcacWrapper = block.querySelector('#wcac-auto-coupons-wrapper');
    const priceEl = block.querySelector('.woocommerce-variation-price');

    const setPromo = (active) => {
        block.classList.toggle('product-price-block--promo', active);
    };

    const setLoading = (active) => {
        block.classList.toggle('product-price-block--loading', active);
    };

    const hasWcac = () => !!wcacWrapper?.querySelector('.wcac-auto-coupons');

    let activeObserver = null;
    let activeTimeout = null;
    let pendingVariation = null;

    const clearPending = () => {
        activeObserver?.disconnect();
        activeObserver = null;
        clearTimeout(activeTimeout);
        activeTimeout = null;
    };

    const reveal = (isPromo) => {
        if (pendingVariation?.price_html && priceEl) {
            const tmp = document.createElement('div');
            tmp.innerHTML = pendingVariation.price_html;
            tmp.querySelectorAll('.seba-wc-omnibus').forEach(el => el.remove());
            priceEl.innerHTML = tmp.innerHTML;
        }
        pendingVariation = null;
        setPromo(isPromo);
        setLoading(false);
    };

    jQuery('form.variations_form')
        .on('found_variation', function (event, variation) {
            clearPending();
            setLoading(true);
            pendingVariation = variation;

            const isOnSale = parseFloat(variation.display_price) !== parseFloat(variation.display_regular_price);

            if (isOnSale) {
                reveal(true);
                return;
            }

            if (!wcacWrapper) {
                reveal(false);
                return;
            }

            activeObserver = new MutationObserver(() => {
                clearPending();
                reveal(hasWcac());
            });
            activeObserver.observe(wcacWrapper, { childList: true, subtree: true });

            activeTimeout = setTimeout(() => {
                clearPending();
                reveal(hasWcac());
            }, 1500);
        })
        .on('reset_data', function () {
            clearPending();
            pendingVariation = null;
            setLoading(false);
            setPromo(false);
        });
};
